<template>
  <div class="siimple-footer siimple-footer--navy siimple-footer--fluid" align="center">
  <transition name="fade">
  <a href="#" v-scroll-to="'#top-position'" class="scroll-top" v-show="isShow">
    PAGE<br />TOP
  </a>
  </transition>

   Copyright (C) 2019 cattery nyankoto<br/>
   All Rights Reserved.
 </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data () {
    return {
      scrollY: 0
    }
  },
  mounted () {
    // スクロールを取得
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('load', () => {
      this.onScroll()
    })
  },
  computed: {
    isShow () {
      return this.scrollY > 200
    }
  },
  methods: {
    // スクロール値の取得
    onScroll () {
      this.scrollY = window.pageYOffset
    }
  }
}
</script>

<style>
.scroll-top {
  position: fixed;
  bottom: 32px;
  right: 32px;
  background-color: #fbc850;
  opacity: 1;
  padding: 10px 11px;
  border-radius: 32px;
  font-weight: bold;
  font-size: 11px;
  color: #fff;
  text-decoration: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue